import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[max-width]',
  standalone: true,
  host: {
    '[style.max-width]': 'maxWidth',
  }
})
export class MaxWidthDirective {

  @Input({ alias: 'max-width' }) maxWidth: string;
}
